import { useEffect, useState } from "react"
import { useLocation, useParams } from "react-router-dom"
import Env from "../../Env"
import LoadingIcon from "../components/icon/LoadingIcon"
import TranslationDashboard from "../translation/TranslationDashboard"

export default () => {

    const location = useLocation()
    const [document_id, setDocument_id] = useState<string>()
    
    useEffect(() => {

        Env.DEBUG && console.log("params: ", location)

        location.search.split("&").forEach(item => {
            const [key, value] = item.split("=")
            if(key === "document_id"){
                const document_id = value
                setDocument_id(document_id)
            }
        })

    }, [location])

    if(!document_id){
        return <div style={{padding: 16}}><LoadingIcon/></div>
    }else{
        return <TranslationDashboard docId={document_id} />
    }

}